import {
  chakra,
  HStack,
  VStack,
  Text,
  useColorModeValue,
  IconButton,
  Box,
  Flex,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

const Card = ({ title, company, description, date, location }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Truncate description to show shorter version
  const shortDescriptionLength = 200;
  const shouldTruncate = description.length > shortDescriptionLength;
  const shortDescription = shouldTruncate
    ? description.substring(0, shortDescriptionLength).trim() + "..."
    : description;

  const displayDescription = isExpanded ? description : shortDescription;

  return (
    <Flex flexDir={"column"} alignItems="center" justifyContent="center" gap={4}>
      <HStack
        pl={0}
        bg={useColorModeValue("none", "none")}
        spacing={20}
        rounded="lg"
        alignItems="top"
        pos="relative"
        h={"100%"}
      >
        <VStack h={"100%"} spacing={2} textAlign="left" w="100%">
          <HStack w="100%" justify="space-between" align="center">
            <chakra.h1 color={"#DD9331"} fontSize="2xl" lineHeight={0.5} fontWeight="bold">
              {title}
            </chakra.h1>
          </HStack>
          <Text fontSize="lg" fontWeight="600" w="100%" color={"#ffffff"}>
            {company}
          </Text>
          {/* Moved location outside of Text component to fix DOM nesting warning */}
          <Text w="100%" fontSize="md" color={"rgb(177, 177, 177)"}>
            {location}
          </Text>

          {/* Description with expand/collapse functionality */}
          <Box w="100%">
            <Text
              color={"#ffffff"}
              whiteSpace={"pre-line"}
              fontSize="md"
              maxH={isExpanded ? "1000px" : "100px"}
              overflow="hidden"
              transition="max-height 0.5s ease"
            >
              {displayDescription}
            </Text>

            {shouldTruncate && (
              <IconButton
                icon={isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
                size="lg"
                fontSize={"4xl"}
                w={"100%"}
                variant="ghost"
                color={"#DD9331"}
                _hover={{
                  color: "#DD9331",
                  fontSize: "6xl",
                  transform: "scale(1.1)",
                }}
                transition={"all 0.3s ease"}
                onClick={() => setIsExpanded(!isExpanded)}
                aria-label={isExpanded ? "Show less" : "Show more"}
                mt={2}
              />
            )}
          </Box>
        </VStack>
      </HStack>
    </Flex>
  );
};

export default Card;
